import { useEffect, useState } from "react"
import {
  ArtBlocksProjectMetadata,
  fetchArtBlocksProjectTokens,
} from "utils/artBlocksMetadataApi"
import { FeatureFilters } from "utils/featureFilters"
import { OrderDirection } from "utils/types"
import { isArtBlocksChainId } from "utils/artBlocksUrls"

interface Params {
  contractAddress: string
  projectId: string
  chainId?: number | string | null
  limit: number
  offset: number
  orderDirection: OrderDirection
  featureFilters?: FeatureFilters
}

const useArtBlocksProjectTokenPage = ({
  contractAddress,
  projectId,
  chainId,
  limit,
  offset,
  orderDirection,
  featureFilters,
}: Params) => {
  const [data, setData] = useState<ArtBlocksProjectMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!contractAddress || !projectId || !isArtBlocksChainId(chainId)) {
      setData(null)
      setLoading(false)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(false)

    fetchArtBlocksProjectTokens({
      contractAddress,
      projectId,
      chainId: Number(chainId),
      limit,
      offset,
      orderDirection,
      featureFilters,
    })
      .then((projectMetadata) => {
        if (!cancelled) setData(projectMetadata || null)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [chainId, contractAddress, featureFilters, limit, offset, orderDirection, projectId])

  return { data, loading, error }
}

export default useArtBlocksProjectTokenPage
